<template>
  <div class="mof-root" :style="themePageStyle">
    <head>
      <meta charset="utf-8" /><title>FLOCKR | My Offers</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" rel="stylesheet" type="text/css" />
    </head>
    <body :data-sidebar="darkMode ? 'dark' : 'light'">
    <div id="layout-wrapper">
      <nav class="mof-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <span class="fw-semibold" style="color:var(--fm-h,#1A1A1A);font-size:15px;">My Offers</span>
          </div>
          <button class="btn btn-sm btn-warning" @click="$router.push('/marketplace')"><i class="mdi mdi-storefront-outline me-1"></i>Marketplace</button>
        </div>
      </nav>

      <div class="container mof-container">
        <!-- Tabs -->
        <div class="mof-tabs mb-3">
          <button class="mof-tab" :class="{active:tab==='received'}" @click="tab='received';fetchReceived()"><i class="mdi mdi-inbox me-1"></i>Received</button>
          <button class="mof-tab" :class="{active:tab==='sent'}" @click="tab='sent';fetchSent()"><i class="mdi mdi-send me-1"></i>Sent</button>
        </div>

        <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

        <div v-else-if="offers.length === 0" class="text-center py-5">
          <i class="mdi mdi-handshake-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
          <h5 class="mt-3" style="color:var(--fm-h,#1A1A1A);">No {{ tab === 'received' ? 'Received' : 'Sent' }} Offers</h5>
          <p style="color:var(--fm-s,#777);">{{ tab === 'received' ? 'Offers from buyers will appear here.' : 'Make offers on listings to see them here.' }}</p>
        </div>

        <div v-else>
          <div v-for="(o,oi) in offers" :key="'o-'+oi" class="mof-card">
            <div class="d-flex align-items-start gap-3">
              <div class="mof-avatar">{{ getInitials(tab==='received'?o.buyer_name:'You') }}</div>
              <div class="flex-fill">
                <div class="d-flex align-items-center gap-2 mb-1">
                  <span class="fw-semibold" style="color:var(--fm-h,#1A1A1A);font-size:14px;">{{ tab === 'received' ? o.buyer_name : 'Your Offer' }}</span>
                  <span class="mof-badge" :class="'st-'+o.status">{{ o.status }}</span>
                </div>
                <div class="fw-semibold" style="color:#BFA164;font-size:15px;">KES {{ formatPrice(o.offered_price) }} <span v-if="o.quantity > 1" style="color:var(--fm-s,#777);font-weight:400;font-size:12px;">× {{ o.quantity }}</span></div>
                <div v-if="o.listing_title" style="color:var(--fm-m,#555);font-size:12px;margin-top:2px;cursor:pointer;" @click="$router.push('/marketplace/listing/'+o.listing_id)">
                  <i class="mdi mdi-tag-outline me-1"></i>{{ o.listing_title }}
                </div>
                <div v-if="o.message" class="mt-1 p-2" style="background:var(--fm-bg2,#0F0F0F);border-radius:6px;color:var(--fm-m,#555);font-size:12px;">{{ o.message }}</div>
                <div v-if="o.counter_price" class="mt-1" style="color:#f1b44c;font-size:12px;"><i class="mdi mdi-swap-horizontal me-1"></i>Counter: KES {{ formatPrice(o.counter_price) }} <span v-if="o.counter_message" style="color:var(--fm-s,#777);">— {{ o.counter_message }}</span></div>
                <div style="color:var(--fm-s,#777);font-size:11px;margin-top:4px;">{{ formatDate(o.created_at) }}</div>
              </div>
            </div>
            <!-- Seller actions on received offers -->
            <div v-if="tab==='received' && o.status==='pending'" class="d-flex gap-2 mt-3 pt-2" style="border-top:1px solid var(--fm-br,#1A1A1A);">
              <button class="btn btn-sm btn-success flex-fill" @click="respond(o.id,'accept')"><i class="mdi mdi-check me-1"></i>Accept</button>
              <button class="btn btn-sm btn-outline-warning flex-fill" @click="counter(o)"><i class="mdi mdi-swap-horizontal me-1"></i>Counter</button>
              <button class="btn btn-sm btn-outline-danger" @click="respond(o.id,'reject')"><i class="mdi mdi-close"></i></button>
            </div>
            <div v-if="tab==='sent' && o.status==='accepted'" class="mt-3 pt-2" style="border-top:1px solid var(--fm-br,#1A1A1A);">
              <button class="btn btn-sm btn-warning text-dark fw-bold w-100" @click="$router.push('/checkout/'+o.id+'?listingId='+o.listing_id)"><i class="mdi mdi-lock me-1"></i>Proceed to Checkout</button>
            </div>
            <div v-if="tab==='received' && o.status==='accepted'" class="mt-3 pt-2 text-center" style="border-top:1px solid var(--fm-br,#1A1A1A);">
              <span style="color:#50C878;font-size:12px;"><i class="mdi mdi-clock-outline me-1"></i>Accepted — Waiting for buyer payment</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    </body>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>
<style>
html[data-theme="light"] .mof-root,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .mof-container{
  background:#F7F5F2!important;
  color:#1A1A1A!important;
}
html[data-theme="dark"] .mof-root,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .mof-container{
  background:#0A0A0A!important;
  color:#F5F0E8!important;
}
html[data-theme="light"] .mof-topbar{
  background:#FFFFFF!important;
  border-bottom-color:#E8E2DA!important;
}
html[data-theme="dark"] .mof-topbar{
  background:rgba(10,10,10,.95)!important;
}
</style>
<style scoped>
.mof-root{background:var(--fm-bg2,#0F0F0F)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)!important}
.mof-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.mof-container{padding-top:80px;padding-bottom:60px;max-width:800px}
.mof-tabs{display:flex;gap:8px}
.mof-tab{padding:8px 20px;border-radius:20px;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg1,#141414)!important;color:var(--fm-m,#555555)!important;font-size:13px;cursor:pointer;transition:all .2s}
.mof-tab:hover{border-color:#BFA164;color:var(--fm-h,#1A1A1A)!important}
.mof-tab.active{background:rgba(191,161,100,.15)!important;border-color:#BFA164;color:#BFA164!important;font-weight:600}
.mof-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:16px;margin-bottom:12px}
.mof-avatar{width:40px;height:40px;border-radius:50%;background:var(--fm-bg3,#1E1E1E)!important;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;color:#BFA164!important;flex-shrink:0}
.mof-badge{padding:2px 8px;border-radius:10px;font-size:10px;font-weight:600;text-transform:capitalize}
.st-pending{background:rgba(241,180,76,.12)!important;color:#f1b44c!important}
.st-accepted{background:rgba(80,200,120,.12)!important;color:#50C878!important}
.st-rejected{background:rgba(255,107,107,.12)!important;color:#FF6B6B!important}
.st-countered{background:rgba(108,180,238,.12)!important;color:#6CB4EE!important}
.st-expired{background:rgba(107,99,86,.2)!important;color:#555555!important}
</style>
<script>
import { executeJson, flocker } from "@/api";
export default {
  name: "MyOffersPage",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true,tab:'received',offers:[]}},
  mounted(){
    this.syncTheme();
    this.themeObserver = new MutationObserver(this.syncTheme);
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    var u=sessionStorage.getItem('userId');if(!u){this.$router.push('/login');return}this.fetchReceived()},
  beforeUnmount(){
    if(this.themeObserver){this.themeObserver.disconnect()}
  },
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},
  },
  methods:{
    syncTheme(){
      var t=document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark';
      window.__flockrSetTheme(t);
      this.darkMode=t!=='light';
      if(document.body){
        document.body.setAttribute('data-sidebar',this.darkMode?'dark':'light');
        document.body.style.background=this.darkMode?'#0A0A0A':'#F7F5F2';
        document.body.style.color=this.darkMode?'#F5F0E8':'#1A1A1A';
      }
    },
    async fetchReceived(){this.loading=true;try{var r=await executeJson({function:"getListingOffers",sellerId:sessionStorage.getItem('userId')},flocker);if(r.data.success)this.offers=r.data.data.offers||[]}catch(e){console.error(e)}this.loading=false},
    async fetchSent(){this.loading=true;try{var r=await executeJson({function:"getListingOffers",buyerId:sessionStorage.getItem('userId')},flocker);if(r.data.success)this.offers=r.data.data.offers||[]}catch(e){console.error(e)}this.loading=false},
    async respond(id,action){try{var r=await executeJson({function:"respondToOffer",offerId:id,action:action},flocker);if(r.data.success){var o=this.offers.find(function(x){return x.id==id});if(o)o.status=action==='accept'?'accepted':'rejected'}}catch(e){console.error(e)}},
    counter(o){var price=prompt('Counter price (KES):');if(price){var msg=prompt('Message (optional):')||'';executeJson({function:"respondToOffer",offerId:o.id,action:'counter',counterPrice:price,counterMessage:msg},flocker).then(function(r){if(r.data.success)o.status='countered'})}},
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    getInitials(n){if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()}
  }
};
</script>